import { Progress } from "antd";

export const contentReportColumns = [
  {
    title: "Content Title",
    dataIndex: "contentTitle",
    key: "contentTitle",
  },
  {
    title: "Type",
    dataIndex: "contentType",
    key: "contentType",
    render: (type) => type?.replace("-", " "),
  },
  {
    title: "Enrolled",
    dataIndex: "enrolledUsers",
    key: "enrolledUsers",
  },
  {
    title: "Completed",
    dataIndex: "completedUsers",
    key: "completedUsers",
  },
  {
    title: "In Progress",
    dataIndex: "inProgressUsers",
    key: "inProgressUsers",
  },
  {
    title: "Not Started",
    dataIndex: "notStartedUsers",
    key: "notStartedUsers",
  },
  {
    title: "Acknowledged",
    dataIndex: "acknowledgedUsers",
    key: "acknowledgedUsers",
  },
  {
    title: "Fully Completed",
    dataIndex: "fullyCompletedUsers",
    key: "fullyCompletedUsers",
  },
 {
  title: "Avg Progress (%)",
  dataIndex: "avgProgress",
  key: "avgProgress",
  render: (value) => {
    const val = parseFloat((value ?? 0).toFixed(2));

    let strokeColor = "#FFB200"; 
    let trailColor = "#FFF8C7";  

    if (val >= 33 && val < 66) {
      strokeColor = "#1777FF"; 
      trailColor = "#E8F1FF"; 
    }

    if (val >= 66) {
      strokeColor = "#088A15"; 
      trailColor = "#EEFFF0"; 
    }

    return (
      <Progress
        percent={val}
        size="small"
        strokeColor={strokeColor}
        trailColor={trailColor}
        format={(percent) => `${percent.toFixed(2)}%`}
      />
    );
  },
}
];